import { HWServiceConfig } from './hw-service-config';

export class HWServiceConfigImpl extends HWServiceConfig {
  constructor(private localServerAddress: string, private globalServerAddressPrefix?: string) {
    super();
  }

  getServerAddress(): string {
    const url: string = this.globalServerAddressPrefix || 'localhost';
    return url + (/:([0-9]+)$/i.test(url) ? '' : ':8001');
  }

  getPhotoServiceAddress(): string {
    return this.getServerAddress() + '/PhotoCabinService/';
  }

  getPhotoControllerV1Address(): string {
    return this.globalServerAddressPrefix + ':8015/';
  }

  getPhotoControllerV1PreviewAddress(suffix: string): string {
    return this.globalServerAddressPrefix + ':8025/' + suffix;
  }

  getPhotoControllerV2Address(): string {
    return this.getServerAddress() + '/PhotoCabinControllerService2/';
  }

  getHWServiceUrl(): string {
    return this.localServerAddress;
  }

  getCameraServiceProtocol(): string {
    return 'camera-ws';
  }

  getPortraitServiceProtocol(): string {
    return 'image-ws';
  }

  getFingerPrintsServiceProtocol(): string {
    return 'fp-ws';
  }

  getPassportReaderServiceProtocol(): string {
    return 'mrtd-ws';
  }

  getSystemServiceProtocol(): string {
    return 'system-ws';
  }

  getLcodServiceProtocol(): string {
    return 'lcod-ws';
  }

  getBCScannerServiceProtocol(): string {
    return 'bcscanner-ws';
  }

  getSignatureScannerServiceProtocol(): string {
    return 'sigscanner-ws';
  }

  getCryptoServiceProtocol(): string {
    return 'crypto-ws';
  }

  getTransportServiceProtocol(): string {
    return 'transport-ws';
  }

  getOpticScannerProtocol(): string {
    return 'opticscanner-ws';
  }

  getTouchScreenProtocol(): string {
    return 'touchscreen-ws';
  }
}
